import { memo } from 'react';

import { UploadIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

export type WorkspaceUploadsEmptyStateProps = {
  onUploadFiles: () => void;
};

export const WorkspaceUploadsEmptyState = memo(({ onUploadFiles }: WorkspaceUploadsEmptyStateProps) => {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 px-6 py-10 text-center"
      data-testid="WORKSPACE_UPLOADS_EMPTY_STATE"
    >
      <span className="flex size-12 shrink-0 items-center justify-center rounded-12 ads:bg-ads-gray-4 bg-gray-4 ads:text-icon-subtle text-gray-9">
        <UploadIcon aria-hidden size="md" />
      </span>
      <div className="block">
        <p className="font-medium ads:text-primary text-14 text-gray-12">No uploads yet</p>
        <p className="max-w-80 ads:text-metadata text-12 text-gray-9">
          Add files or a folder and you&apos;ll see them here as they upload.
        </p>
      </div>
      <Button
        appearance="filled"
        color="blue"
        data-testid="WORKSPACE_UPLOADS_UPLOAD_FILES_BUTTON"
        onClick={onUploadFiles}
        size="small"
        type="button"
      >
        Upload files
      </Button>
    </div>
  );
});

WorkspaceUploadsEmptyState.displayName = 'WorkspaceUploadsEmptyState';
